import React from "react";
import styles from "./index.module.scss";
import { Sidebar } from "primereact/sidebar";
import SearchComponent from "../search-component";

interface propsType {
  showSearch: boolean;
  setShowSearch: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function SearchMobile({ showSearch, setShowSearch }: propsType) {
  return (
    <Sidebar
      visible={showSearch}
      position="top"
      onHide={() => setShowSearch(false)}
      className={styles.SearchModel}
    >
      <SearchComponent setShowSearch={setShowSearch} />
    </Sidebar>
  );
}
